import { defineSlotRecipe } from '@chakra-ui/react'
import { tooltipAnatomy } from '@chakra-ui/react/anatomy'

const gsk = {
    content: {
        borderRadius: '16px',
        border: '1px solid',
        padding: '24px',
        fontSize: '14px',
        fontWeight: '400',
        lineHeight: '20px',
        textAlign: 'justify',
        _light: {
            backgroundColor: 'white',
            borderColor: 'surface.dark',
            color: 'dark.700',
        },
        _dark: {
            backgroundColor: 'black',
            borderColor: 'rgba(84, 79, 64, 0.4)',
            color: 'white',
        },
    },
}

const settings = {
    content: {
        ...gsk.content,
        letterSpacing: '0.25px',
        minWidth: '345px',
        padding: '24px',
    },
}
const search = {
    content: {
        ...gsk.content,
        width: '100%',
        maxWidth: '600px',
    },
}

export const tooltipSlotRecipe = defineSlotRecipe({
    slots: tooltipAnatomy.keys(),
    variants: { variant: { gsk, settings, search } },
})
